import { Box, Stack, Typography } from "@mui/material";

import { formatMoney } from "../../../../../shared/utils/formatMoney";
import { fmtCompactDateRange } from "../../../../../shared/utils/dateFormat";

function formatNumber(value, maximumFractionDigits = 2) {
  const number = Number(value);
  return Number.isFinite(number)
    ? number.toLocaleString("es-AR", { maximumFractionDigits })
    : "—";
}

function SummaryItem({ label, value, fullWidth = false }) {
  return (
    <Box sx={{ gridColumn: fullWidth ? "1 / -1" : "auto", minWidth: 0 }}>
      <Typography sx={{ color: "neutral.700", fontSize: 11, fontWeight: 700 }}>
        {label}
      </Typography>
      <Typography
        sx={{ mt: 0.35, color: "primary.900", fontSize: 16, fontWeight: 750, overflowWrap: "anywhere" }}
      >
        {value}
      </Typography>
    </Box>
  );
}

export default function SalesImportDraftSummary({ draft }) {
  if (!draft?.id) return null;

  return (
    <Stack
      component="section"
      aria-label="Resumen del archivo"
      spacing={1.5}
      sx={{
        p: 2,
        borderRadius: "24px",
        bgcolor: "neutral.100",
        boxShadow: "inset 0px 0px 3px rgba(117, 117, 138, 0.22)",
      }}
    >
      <Typography component="h2" sx={{ color: "primary.900", fontSize: 17, fontWeight: 800 }}>
        Resumen
      </Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 1.6 }}>
        <SummaryItem
          label="Período de ventas"
          value={fmtCompactDateRange(draft.salesDateFrom, draft.salesDateTo)}
          fullWidth
        />
        <SummaryItem label="Filas procesadas" value={formatNumber(draft.processedRows, 0)} />
        <SummaryItem label="Unidades vendidas" value={formatNumber(draft.totalUnitsSold)} />
        <SummaryItem label="Comprobantes" value={formatNumber(draft.distinctReceiptCount, 0)} />
        <SummaryItem
          label="Productos diferentes"
          value={formatNumber(draft.distinctProductCount, 0)}
        />
        <SummaryItem label="Importe de ventas" value={formatMoney(draft.totalSalesAmount)} fullWidth />
      </Box>
    </Stack>
  );
}
